export const SOCIAL_PATTERNS = {
  facebook: /^https?:\/\/(www\.|m\.|web\.)?facebook\.com\/(?!share|sharer|dialog|plugins|ads|groups\/discover)(profile\.php\?id=(\d+)|(\d+)|([a-zA-Z0-9._-]{3,50}))\/?(\?.*)?$/,
  instagram: /^https?:\/\/(www\.)?instagram\.com\/(?!explore|accounts|about|developer|legal|p\/|reel\/|stories\/)([a-zA-Z0-9._]{1,30})\/?(\?.*)?$/,
  tiktok: /^https?:\/\/(www\.|vm\.|vt\.)?tiktok\.com\/(@([a-zA-Z0-9._]{2,24})|(h5\/)?share\/(user|usr)\/([0-9]+))\/?(\?.*)?$/,
  youtube: /^https?:\/\/(www\.)?youtube\.com\/(channel\/(UC[a-zA-Z0-9_-]{22})|@([a-zA-Z0-9._-]{3,30})|c\/([a-zA-Z0-9._-]+)|user\/([a-zA-Z0-9._-]+))\/?(\?.*)?$/,
  twitch: /^https?:\/\/(www\.)?twitch\.tv\/(?!directory|p\/|jobs|downloads)([a-zA-Z0-9_]{4,25})\/?(\?.*)?$/
};

// Per-platform: indexes of regex capture groups that hold the influencer identifier.
// Tried in order; first non-empty match wins.
const IDENTIFIER_GROUPS = {
  facebook: [3, 4, 5],     // id (profile.php), numericId, username
  instagram: [2],          // username
  tiktok: [3, 6],          // @username, shareId
  youtube: [3, 4, 5, 6],   // channelId, handle, custom, user
  twitch: [2]              // username
};

export const PLATFORM_ERRORS = {
  facebook: 'This is not a Facebook profile link. Use the profile page, e.g. facebook.com/username or facebook.com/profile.php?id=123.',
  instagram: 'This is not an Instagram profile link. Use the profile page, e.g. instagram.com/username. Posts, reels and stories are not accepted.',
  tiktok: 'This is not a TikTok profile link. Use the profile page, e.g. tiktok.com/@username.',
  youtube: 'This is not a YouTube channel link. Use the channel page, e.g. youtube.com/@channel. Single videos are not accepted.',
  twitch: 'This is not a Twitch channel link. Use the channel page, e.g. twitch.tv/username.'
};

export const GENERIC_ERROR = 'Unsupported link. Paste a profile link from Instagram, TikTok, YouTube, Facebook or Twitch.';

const DOMAIN_HINTS = [
  { match: /facebook\.com|fb\.com/i, platform: 'facebook' },
  { match: /instagram\.com/i, platform: 'instagram' },
  { match: /tiktok\.com/i, platform: 'tiktok' },
  { match: /youtube\.com|youtu\.be/i, platform: 'youtube' },
  { match: /twitch\.tv/i, platform: 'twitch' }
];

export function stripQuery(url) {
  const trimmed = (url || '').trim();
  const idx = trimmed.indexOf('?');
  return idx === -1 ? trimmed : trimmed.slice(0, idx);
}

export function detectPlatformHint(url) {
  const s = (url || '').trim().toLowerCase();
  for (const { match, platform } of DOMAIN_HINTS) {
    if (match.test(s)) return platform;
  }
  return null;
}

function extractIdentifier(platform, match) {
  const indices = IDENTIFIER_GROUPS[platform] || [];
  for (let i = 0; i < indices.length; i++) {
    const v = match[indices[i]];
    if (v) return v;
  }
  return '';
}

export function validateChannel(url) {
  const trimmed = (url || '').trim();
  const cleanUrl = stripQuery(trimmed);
  for (const [platform, pattern] of Object.entries(SOCIAL_PATTERNS)) {
    const m = cleanUrl.match(pattern);
    if (m) {
      return {
        valid: true,
        platform,
        identifier: extractIdentifier(platform, m),
        cleanUrl,
        error: null
      };
    }
  }

  const hint = detectPlatformHint(trimmed);
  return {
    valid: false,
    platform: hint,
    identifier: null,
    cleanUrl,
    error: hint ? PLATFORM_ERRORS[hint] : GENERIC_ERROR
  };
}

export function validateChannelForPlatform(url, platform) {
  const pattern = SOCIAL_PATTERNS[platform];
  if (!pattern) {
    return { valid: false, platform, identifier: null, cleanUrl: stripQuery(url), error: GENERIC_ERROR };
  }
  const cleanUrl = stripQuery(url);
  const m = cleanUrl.match(pattern);
  if (!m) {
    return { valid: false, platform, identifier: null, cleanUrl, error: PLATFORM_ERRORS[platform] };
  }
  return {
    valid: true,
    platform,
    identifier: extractIdentifier(platform, m),
    cleanUrl,
    error: null
  };
}



// WEBPACK FOOTER //
// ./src/utils/socialChannels.js